import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { PartService } from 'pages/quote-setup/parts/service';
import { formatTableLink } from 'resources/utility';

@inject(PartService, Router)
export class WhereUsed {
    constructor(partService, router) {
        this.partService = partService;
        this.router = router;

        this.filter = {
            requestType: 'Parent'
        };

        this.columns = [
            { dataField: 'quoteId', caption: 'QS#', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { dataField: 'plantName', caption: 'Plant' },
            { dataField: 'projectName', caption: 'Project' },
            { dataField: 'customerName', caption: 'Customer' },
            { dataField: 'partNumber', caption: 'Part' }
        ];
        
        this.data = [];
    }

    async search() {
        if (this.filter.partId == null) return;
        this.isSearching = true;
        this.data = await this.partService.whereUsed(this.filter);
        this.grid.refresh();
        this.isSearching = false;
    }

    edit = (data) => {
        this.router.navigate(`quote/edit/${data.quoteId}`);
    };
}